import React from "react";
import MUILink from "@mui/material/Link";
import { getClassName } from "@sscs/utils";
import { Link as RouterLink, } from "react-router";
import styles from "./link.module.scss";
const Link = React.forwardRef(({ id, to, href, inline = false, underline = "always", fullWidth = true, relative = "route", preventScrollReset = false, title, className, onClick, children, ...props }, ref) => {
    const classes = getClassName(styles.link, className, {
        [styles.inline]: inline,
        [styles["full-width"]]: fullWidth && !inline,
    });
    if (to === undefined) {
        return (React.createElement(MUILink, { ...props, ref: ref, id: id, href: href, underline: underline, className: classes, title: title, onClick: onClick }, children));
    }
    else {
        return (React.createElement(MUILink, { ...props, ref: ref, id: id, to: to, component: RouterLink, relative: relative, underline: underline, className: classes, title: title, preventScrollReset: preventScrollReset, onClick: onClick }, children));
    }
});
Link.displayName = "Link";
export default Link;
//# sourceMappingURL=Link.js.map